// Olive Travel is the site's booking engine. The bootstrap script in
// public/index.html mounts Olive's trip pill on "/" and its rooms/booking
// widget on "/rooms"; this is the property that script is configured for.
export const OLIVE_PROPERTY_SLUG = "annex-toronto";

// "/rooms" is the customRoomsPageUrl configured for the property, i.e. the page
// Olive's own trip pill sends guests to when they search. Olive's widget reads
// the trip off the hash rather than the query string, so our booking entry
// points build the same link the pill would.
export const OLIVE_BOOKING_PATH = "/rooms";

// Olive expects plain YYYY-MM-DD in the guest's local calendar days, not a
// UTC timestamp - toISOString() would shift the date across midnight for
// anyone west of Greenwich.
const formatOliveDate = (date: Date) => {
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

const isValidDate = (date?: Date) =>
  !!date && date instanceof Date && !isNaN(date.getTime());

// Hash portion of the booking link, e.g. "#/annex-toronto/?startDate=2026-09-01".
// Omitting the dates is fine: Olive then falls back to the guest's stored trip.
export const getOliveBookingHash = (startDate?: Date, endDate?: Date) => {
  const trip = new URLSearchParams();

  if (isValidDate(startDate)) {
    trip.set("startDate", formatOliveDate(startDate as Date));
  }
  if (isValidDate(endDate)) {
    trip.set("endDate", formatOliveDate(endDate as Date));
  }

  const query = trip.toString();
  return `#/${OLIVE_PROPERTY_SLUG}/${query ? `?${query}` : ""}`;
};
